import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import { AdventCalendar } from '@sorare/marketplace/src/components/NeonChristmas/AdventCalendar';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

const AdventCalendarPage = () => {
  return (
    <Wrapper>
      <AdventCalendar />
    </Wrapper>
  );
};
export default AdventCalendarPage;
